import React from 'react';
import '../styles/pages/PrivacyPolicyPage.css';

const PrivacyPolicyPage = () => {
  return (
    <main className="privacy-policy-page">
      <section className="policy-header-section">
        <div className="container">
          <h1 className="policy-title">Privacy Policy</h1>
          <p className="policy-updated">Last updated: December 28, 2025</p>
        </div>
      </section>

      <section className="policy-content-section py-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="policy-content">
                <h2>Introduction</h2>
                <p>
                  At Supernova Lab, we are committed to protecting your privacy and ensuring the security 
                  of your personal information. This Privacy Policy explains how we collect, use, disclose, 
                  and safeguard your information when you visit our website or use our services.
                </p>

                <h2>Information We Collect</h2>
                <h3>Personal Information</h3>
                <p>
                  We may collect personal information that you voluntarily provide to us when you:
                </p>
                <ul>
                  <li>Register for our newsletter</li>
                  <li>Submit an inquiry or contact form</li>
                  <li>Register for events or workshops</li>
                  <li>Apply to become a Lab Fellow</li>
                  <li>Download resources or tools</li>
                </ul>

                <h3>Automatically Collected Information</h3>
                <p>
                  When you visit our website, we may automatically collect certain information about your device, 
                  including information about your web browser, IP address, time zone, and some of the cookies 
                  installed on your device.
                </p>

                <h2>How We Use Your Information</h2>
                <p>
                  We use the information we collect to:
                </p>
                <ul>
                  <li>Provide, operate, and maintain our services</li>
                  <li>Send you newsletters and updates</li>
                  <li>Respond to your inquiries and requests</li>
                  <li>Process your registrations for events</li>
                  <li>Improve our website and services</li>
                  <li>Analyze usage trends and preferences</li>
                </ul>

                <h2>Information Sharing</h2>
                <p>
                  We do not sell, trade, or rent your personal information to third parties. We may share your 
                  information with trusted third-party service providers who assist us in operating our website 
                  and conducting our business, provided they agree to keep this information confidential.
                </p>

                <h2>Data Security</h2>
                <p>
                  We implement appropriate technical and organizational security measures to protect your personal 
                  information. However, no method of transmission over the Internet is 100% secure, and we cannot 
                  guarantee absolute security.
                </p>

                <h2>Your Rights</h2>
                <p>
                  You have the right to:
                </p>
                <ul>
                  <li>Access your personal information</li>
                  <li>Correct inaccurate information</li>
                  <li>Request deletion of your information</li>
                  <li>Object to processing of your information</li>
                  <li>Unsubscribe from our communications</li>
                </ul>

                <h2>Contact Us</h2>
                <p>
                  If you have any questions about this Privacy Policy, please contact us at:
                </p>
                <p>
                  <strong>Email:</strong> hq@supernovalab.ai<br />
                  <strong>Address:</strong> Bridgetown, Barbados
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default PrivacyPolicyPage;